import React from "react";
import SummaryDetailsItem from "./SummaryDetailsItem";
import SummaryDetailsProps from "../../../../types/SummaryDetailsProps";

type SummaryDetailsPersonItemsProps = {
  basePath: string;
  caseData: SummaryDetailsProps["caseData"];
};

export default function SummaryDetailsPersonItems({ basePath, caseData }: SummaryDetailsPersonItemsProps) {
  return (
    <>
      <SummaryDetailsItem fieldPath={basePath + ".gender"} caseData={caseData} />
      <SummaryDetailsItem fieldPath={basePath + ".givenName"} caseData={caseData} />
      <SummaryDetailsItem fieldPath={basePath + ".familyName"} caseData={caseData} />
      <SummaryDetailsItem fieldPath={basePath + ".residenceAddress.streetAddress"} caseData={caseData} />
      <SummaryDetailsItem fieldPath={basePath + ".residenceAddress.postalCode"} caseData={caseData} />
      <SummaryDetailsItem fieldPath={basePath + ".residenceAddress.addressLocality"} caseData={caseData} />
    </>
  );
}
